import * as React from 'react';
import { memo } from 'react';

const StandBy: React.FunctionComponent = () => {
    return <div>The other team is guessing. Please wait.</div>;
};
export default memo(StandBy);
